<template>
  <div class="activityCenter">
    <div class="activity_header">
      <div>
        <i @click.stop="goBack" class="iconfont icon-xiangyou" :class="[isDirection ? '' : 'mirrorRotateLevel']"></i>
      </div>
      <div>
        <i class="copy iconfont icon-fenxiang" @click="handleCopy" :data-clipboard-text="url"
           :class="[isDirection ? 'mirrorRotateLevel' : '']"></i>
      </div>
    </div>
    <div class="main">
      <div class="main_header">
        <svg slot="image" class="icon" aria-hidden="true">
          <use xlink:href="#icon-renwuzhongxin"></use>
        </svg>
        <!--      活动中心-->
        <span class="bold">{{ $t('300358') }}</span>
      </div>
      <div class="main_body">
        <div class="horse_loop">
          <div>
            <!--          <span class="bold">{{ $t('300364') }}:</span>-->
            <horse-lamps v-if="joinUserList.length" speed="50">
              <div class="trotting-horse-lamp2 ul50">
                <div class="userHorseLoop" v-for="(item, index) in joinUserList" :key="index">
                  <p class="bold" v-if="item.type === 1"><img :class="[isDirection ? 'mirrorRotateLevel' : '']"
                                                              src="../../../static/images/coin.png"/><span>{{ item.notice }}</span>
                  </p>
                  <p v-if="item.type === 2" class="winnerMsg bold"><span class="bold"></span><img
                    :class="[isDirection ? 'mirrorRotateLevel' : '']" src="../../../static/images/coin.png"/><span
                    class="content">{{ item.eventName }}&emsp;{{
                      $t('300357', {
                        user: item.awardeeName,
                        shop: item.awardGoods
                      })
                    }}</span></p>
                </div>
              </div>
            </horse-lamps>
          </div>
        </div>
        <div class="activity_list">

          <van-skeleton class='productListSkeleton' :row="1" :loading="loading1">
            <div v-masonry></div>
          </van-skeleton>
          <van-list
            offset="50"
            v-model="loading"
            v-if="list.length>0"
            :finished="finished"
            loading-text=" "
            finished-text=" "
            @load="onLoad"
          >
            <van-cell v-for="(item,index) in list" :key="item.id">
              <div class="activity_item">
                <!--          <div class="image" :style="{backgroundImage:'url(' + this.background + ')'}"></div>-->
                <div class="image">
                  <span class="activity_state beInProgress" v-if="item.eventState == 2">{{ $t('300359') }}</span>
                  <!--                正在进行中-->
                  <span class="activity_state isAbouttToBegin" v-if="item.eventState == 1">{{ $t('300360') }}</span>
                  <!--                即将开始-->
                  <span class="activity_state hasEnded" v-if="item.eventState == 3">{{ $t('300361') }}</span>
                  <!--                已结束-->
                  <img :src="item.img" alt=""/>
                  <div v-if="item.eventAwards.length" class="prizeUser bold">
                    <span>{{ $t('300364') }}:</span>
                    <van-swipe vertical :touchable="false" class="notice-swipe" :autoplay="1500"
                               :show-indicators="false">
                      <van-swipe-item v-for="(items,index) in item.eventAwards" :key="index">
                        <img
                          :class="{mirrorRotateLevel:isDirection}"
                          src="../../../static/images/coin.png"
                          alt
                        />
                        <p>{{ items.eventName }}{{
                            $t('300357', {
                              user: items.awardeeName,
                              shop: items.awardGoods
                            })
                          }}</p>
                      </van-swipe-item>
                    </van-swipe>
                  </div>
                  <div v-if="!item.eventAwards.length && item.eventState == 3" class="willBeAnnouncedSoon bold">
                    {{ $t('300365') }}
                  </div>
                </div>
                <div class="activity_describe">
                  <div class="activity_title bold">{{ item.eventName }}</div>
                  <div class="line"></div>
                  <div class="activity_text" v-html="item.awardIntroduction"></div>
                  <div class="date_time">{{ getTime(item.startTime) }} - {{ getTime(item.endTime) }}</div>
                  <van-button v-if="item.eventState == 2" @click="toActivity(item)">{{ $t('300362') }}</van-button>
                  <van-button v-if="item.eventState == 3" disabled>{{ $t('300361') }}</van-button>
                  <van-button v-if="item.eventState == 1" disabled>{{ $t('300360') }}</van-button>
                </div>
              </div>
            </van-cell>
          </van-list>

          <van-skeleton v-if="list.length===0" class='productListSkeleton' :row="1" :loading="loading1">
            <div v-masonry></div>
          </van-skeleton>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {mapGetters} from "vuex";
import {Button, List, Cell, Swipe, SwipeItem, Toast, Skeleton} from "vant";
import {getActivity, getActivityLoop} from './activity'
import {getLanguageList} from "../../api/user";
import {getCookie, removeToken, setToken} from "../../utils/auth";
import HorseLamps from "../purchase/compontents/horselamps.vue"
import Clipboard from 'clipboard'
import {getShopStore} from "../purchase/api";

export default {
  name: "index",
  components: {
    VanSwipeItem: SwipeItem,
    VanSwipe: Swipe,
    vanButton: Button,
    vanList: List,
    vanCell: Cell,
    HorseLamps,
    VanSkeleton: Skeleton
  },
  data() {
    return {
      list: [],
      listQuery: {
        page: 1,
        pageSize: 10
      },
      total: 0,
      joinUserList: [],
      url: '',
      loading: false,
      finished: false,
      ind: 1,
      loading1: true,
      isHaveIsApp: ''
    }
  },
  computed: {
    ...mapGetters(['isDirection', 'isApp'])
  },
  created() {
    this.url = window.location.origin + `/activity?language=${this.$route.query.language}`
    this.isHaveIsApp = (this.isApp || this.$route.query.isApp) ? '&isApp=1' : ''
    this.resher()
    this.getList() //获取数据列表
    this.horseLamp() //获取中奖信息和通告
  },
  methods: {
    toActivity(item) {
      console.log(item, '看看这里的item---');
      if (item.h5Url) {
        if (item.h5Url.indexOf('/anniversary') != -1) {
          let isHaveToken = this.$route.query.token ? `&token=${this.$route.query.token}` : ''
          this.$router.push(item.h5Url + `&isBanner=0` + `&language=${this.$route.query.language}` + this.isHaveIsApp + '&backgroundColor=' + this.$route.query.backgroundColor + isHaveToken)
        } else {
          this.$router.push(item.h5Url + `&isBanner=0` + `&language=${this.$route.query.language}` + this.isHaveIsApp + '&backgroundColor=' + this.$route.query.backgroundColor)
        }
      }
    },
    onLoad() {
      // 异步更新数据
      // setTimeout 仅做示例，真实场景中一般为 ajax 请求
      this.loading = true;
      setTimeout(() => {
        if (this.list.length === this.total) {
          this.finished = true;
          this.loading = false;
          return
        }
        this.ind++;
        getActivity({page: this.ind, pageSize: 10}).then(res => {
          this.list = this.list.concat(res.data.items)
          this.total = res.data.total
          this.loading = false;
        }).catch(e => {
          this.ind--
          this.loading = false
        })
        // 加载状态结束

        // 数据全部加载完成

      }, 1000);
    },
    handleCopy() {
      var clipboard = new Clipboard('.copy')
      clipboard.on('success', e => {
        Toast.success(this.$t('300027'))
        // 释放内存
        clipboard.destroy()
      })
      clipboard.on('error', e => {
        Toast.fail(this.$t('300028'))
        // 释放内存
        clipboard.destroy()
      })
    },
    goBack() {
      if (this.isApp == 1 || this.$route.query.isApp == 1) {
        removeToken()
        this.$jsBridge.callHandler(
          this.$jsBridgeCmd.goBack,
          {},
          (data) => {
          }
        )
      } else {
        this.$router.push('/newIndex')
      }
    },
    resher() {
      var token = this.$route.query.token;
      window.document.documentElement.setAttribute(
        'data-theme',
        this.$route.query.backgroundColor === 'day' ? 'sunlight' : 'moon'
      )
      if (this.$route.query.language) {
        this.$store.dispatch('setLanguage', this.$route.query.language)
        getLanguageList().then(res => {
          let el = res.data.find(item => {
            return item.language == this.$route.query.language
          })
          // this.$store.dispatch('setLanguageName', el.name)
          this.$i18n.locale = this.$route.query.language;
          this.$store.dispatch(
            "setIsDirection",
            this.$route.query.language == "fa" || this.language == 'fa' ? true : false
          );
          window.document.documentElement.setAttribute(
            "dir",
            this.isDirection ? "rtl" : "ltr"
          );
        })
      } else {
        let language = getCookie('language');
        this.$store.dispatch('setLanguage', language)
        getLanguageList().then(res => {
          let el = res.data.find(item => {
            // console.log(item)
            return item.language == language
          })

          this.$store.dispatch('setLanguageName', el.name)
        })
        this.$i18n.locale = language;
        this.$store.dispatch(
          "setIsDirection",
          language == "fa" || this.language == 'fa' ? true : false
        );
        window.document.documentElement.setAttribute(
          "dir",
          this.isDirection ? "rtl" : "ltr"
        );
      }
      if (this.$route.query.isApp == 1) {
        this.$store.dispatch("setisApp", this.$route.query.isApp);
        // removeToken()
        if (token) {
          this.$store.dispatch('setToken', token);
          setToken(token);
          this.isLogin = true;
        } else {
          removeToken();
          this.isLogin = false;
        }
      } else {
        this.isLogin = getCookie("token") ? true : false;
        if (this.isLogin) {
        } else {
          removeToken();
        }
      }
      this.$store.dispatch(
        "setIsDirection",
        this.$route.query.language == "fa" || this.language == 'fa' ? true : false
      );
      window.document.documentElement.setAttribute(
        "dir",
        this.isDirection ? "rtl" : "ltr"
      );
    },
    horseLamp() {
      getActivityLoop().then((res) => {
        this.joinUserList = this.filterData(res.data.noticeAwardList)
      })
    },
    filterData(val) {
      let data = []
      val.forEach((item) => {
        if (item.notice) {
          data.push({
            type: 1,
            notice: item.notice,
          })
        }
        if (item.eventAwards) {
          data.push({
            type: 2,
            ...item.eventAwards,
          })
        }
      })
      return data
    },
    getTime(time) {
      if (!time) return
      let timer = new Date(time)
      let year = timer.getFullYear()
      let Month = timer.getMonth() + 1
      let day = timer.getDate()
      let hour =
        timer.getHours() >= 10
          ? timer.getHours()
          : '0' + timer.getHours()
      let minutes =
        timer.getMinutes() >= 10
          ? timer.getMinutes()
          : '0' + timer.getMinutes()
      return `${year}/${Month}/${day} ${hour}:${minutes}`
      // return parseTime(time,'{y}/{m}/{d} {h}:{m}')
    },
    getList() {
      getActivity(this.listQuery).then(res => {
        this.list = res.data.items
        this.total = res.data.total
        this.loading1 = false
      })
    }
  }
}
</script>

<style lang="scss" scoped>
@import "../../style/mixin";
@import "../../assets/css/mixin";
@import "../../assets/css/variableName";

/deep/ .van-skeleton__row {
  width: 100% !important;
  height: 100% !important;
  border-radius: torem(8);
}

.activityCenter {
  position: fixed;
  width: 100vw;
  min-height: 100vh;
  top: 0;
  left: 0;
  //background: #fff;
  @include background_color('background-color-2');
  padding-bottom: env(safe-area-inset-bottom);
}

.activity_header {
  height: torem(44);
  padding: 0 torem(16);
  box-sizing: border-box;
  display: flex;
  justify-content: space-between;
  align-items: center;

  > div {
    &:first-child {
      i {
        width: torem(14);
        height: torem(18);
      }
    }
  }

  i {
    font-size: torem(18);
    display: inline-block;
    @include font_color('font-color');
  }
}

.main_header {
  display: flex;
  align-items: center;
  padding: 0 torem(16);
  margin: torem(12) 0 torem(16) 0;

  svg {
    width: torem(24);
    height: torem(24);
  }

  span {
    font-size: torem(20);
    //color: rgba(0, 9, 34, 1);
    @include font_color('font-color-3');
    margin: 0 torem(8);
  }
}

.horse_loop {
  height: torem(124);
  width: 100%;
  border-radius: torem(16) torem(16) 0 0;
  background: linear-gradient(to right, rgba(255, 239, 154, 1), rgba(205, 255, 153, 1), rgba(158, 251, 255, 1));;
}

.activity_list {
  padding: 0 torem(16) torem(128);
  position: absolute;
  @include background_color('background-color-2');
  box-sizing: border-box;
  top: torem(32);
  left: 0;
  width: 100%;
  background: rgba(255, 255, 255, 1);
  border-radius: torem(16) torem(16) 0 0;
  min-height: 100vh;
}

.activity_item {
  margin-top: torem(16);
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  box-sizing: border-box;
  border: torem(1) solid;
  @include border_color('border-color');
  border-radius: torem(10);

  .image {
    flex-shrink: 0;
    width: 100%;
    height: torem(171.5);
    position: relative;
    //background: no-repeat center;
    //background-size:cover ;
    > img {
      width: 100%;
      height: 100%;
      object-fit: cover;
      border-radius: torem(8);
    }

    border-radius: torem(8);
  }

  .activity_describe {
    padding: torem(8) torem(16) torem(16);
    margin-top: torem(12);
    width: 100%;
    @include font-color('font-color');

    .activity_title {
      width: 100%;
      text-align: start;
      word-break: break-all;
      font-size: torem(15);
      //color: rgba(0, 9, 34, 1);
      line-height: torem(17.58);
      text-overflow: -o-ellipsis-lastline;
      overflow: hidden;
      text-overflow: ellipsis;
      display: -webkit-box;
      -webkit-line-clamp: 2;
      line-clamp: 2;
      -webkit-box-orient: vertical;
      //display: flex;
    }

    .activity_text {
      text-align: start;
      width: 100%;
      word-break: break-all;
      font-size: torem(13);
      //color:rgba(127, 132, 144, 1) ;
      @include font_color('disale-color');
      line-height: torem(19.5);
      text-overflow: -o-ellipsis-lastline;
      overflow: hidden;
      text-overflow: ellipsis;
      display: -webkit-box;
      -webkit-line-clamp: 2;
      line-clamp: 2;
      -webkit-box-orient: vertical;
      //display: flex;
    }

    .date_time {
      width: 100%;
      text-align: start;
      margin: torem(8) 0 torem(24) 0;
      font-size: torem(12);
      @include font_color('disale-color');
      //display: flex;
    }

    .line {
      height: torem(1);
      width: torem(311);
      margin: torem(8) 0;
      @include background_color('border-color-1');
    }

    .van-button {
      width: torem(311);
      height: torem(44);
      background: rgba(255, 199, 43, 1);
      color: rgba(0, 0, 0, 0.90);
      font-size: torem(14);
      border-radius: torem(4);
      border-color: rgba(255, 199, 43, 1);
    }

    .van-button--disabled {
      //color: rgba(127, 132, 144, 1);
      @include font-color('disale-color');
      @include background_color('disable-btn-1');
      @include border_color('disable-btn-1');
    }
  }
}

.main_body {
  position: relative;
}

.main {
  height: 100vh;
  overflow-y: auto;
  -webkit-overflow-scrolling: touch;
}

.van-list {
  width: torem(343);

  .van-cell {
    padding: 0 !important;
    background: transparent;

    &:after {
      border-bottom: none;
    }

  }
}

.willBeAnnouncedSoon, .prizeUser {
  position: absolute;
  height: torem(30);
  line-height: torem(30);
  width: torem(343);
  border-radius: 0 0 torem(6) torem(6);
  background: linear-gradient(to right, rgba(255, 239, 154, 1), rgba(205, 255, 153, 1), rgba(158, 251, 255, 1));
  font-size: torem(12);
  bottom: 0;
}

.willBeAnnouncedSoon {
  text-align: center;
}

.activityCenter {
  .main_body {
    .prizeUser {
      display: flex;
      align-items: center;
      padding: 0 torem(12);
      box-sizing: border-box;

      span {
        color: rgba(0, 9, 34, 1);
        z-index: 99;
        line-height: torem(30);
        flex-shrink: 0;
      }

      .notice-swipe {
        z-index: 99;
        height: torem(30);

        .van-swipe-item {
          display: flex;
          align-items: center;
          height: torem(30);
          line-height: torem(30);

          p {

            overflow: hidden;
            white-space: nowrap;
            text-overflow: ellipsis;
            -o-text-overflow: ellipsis;
          }

          img {
            width: torem(16);
            height: torem(16);
            margin: 0 torem(6);
          }
        }
      }
    }
  }
}

.activity_state {
  display: inline-block;
  position: absolute;
  top: torem(20);
  padding: torem(4) torem(8);
  border-radius: torem(2);
  font-size: torem(14);
  line-height: torem(14);
}

.beInProgress {
  background: rgba(0, 180, 100, 1);
  color: rgba(255, 255, 255, 1);
}

.isAbouttToBegin {
  background: rgba(255, 199, 43, 1);
  color: rgba(0, 9, 34, 1);
}

.hasEnded {
  background: rgba(250, 77, 86, 1);
  color: rgba(255, 255, 255, 1);
}

.activity_text {
  > p {
    display: flex;
  }
}

.trotting-horse-lamp2 {
  display: flex;
}

.userHorseLoop {
  display: flex;
  align-items: center;
  flex-shrink: 0;

  p {
    display: flex;
    align-items: center;
    line-height: torem(32);
    font-size: torem(12);
    color: rgba(0, 9, 34, 1);

    img {
      width: torem(16);
      height: torem(16);

    }

    height: torem(32);
    //line-height: torem(32);
    flex-shrink: 0;
  }
}

.horse_loop {
  > div {
    height: torem(32);
    display: flex;
    align-items: center;

    span {
      font-size: torem(12);
      color: rgba(0, 9, 34, 1);
      flex-shrink: 0;
    }
  }

  padding: 0 torem(16);

}

/deep/ .purchase_out_box {
  height: torem(32);
}

.productListSkeleton {
  height: torem(388.5);

  .van-skeleton__row {
    border: torem(1) solid;
    @include border_color('border-color');
    @include background_color('background-color-2');
  }

  width: 100%;
  margin-top: torem(16);
}
</style>
<style lang="scss" scoped>
@import "../../style/mixin";
@import "../../assets/css/variableName";

[dir='ltr'] .activityCenter {
  .activity_state {
    left: torem(20);
  }

  .horse_loop {
    > div {
      span {
        margin-right: torem(16);
      }
    }
  }

  .userHorseLoop {
    &:first-child {
      margin-left: 0 !important;
    }

    p {
      img {
        margin: 0 torem(4) 0 0;
      }
    }
  }
}

[dir='rtl'] .activityCenter {
  .activity_state {
    right: torem(20);
  }

  .horse_loop {
    > div {
      span {
        margin-left: torem(16);
      }
    }
  }

  .userHorseLoop {
    &:first-child {
      margin-right: 0 !important;
    }

    p {
      img {
        margin: 0 0 0 torem(4);
      }
    }
  }
}

::-webkit-scrollbar {
  display: none;
}
</style>



// WEBPACK FOOTER //
// src/view/activityCenter/index.vue